import {z} from 'zod';

import {usageSchema} from '../common/UsageSchema';

/**
 * Response schema for usage summary containing aggregated usage data
 */
export const getUsageSummaryResponseSchema = z.object({
  totalInputTokens: z.number(),
  totalOutputTokens: z.number(),
  totalTokens: z.number(),
  requestCount: z.number(),
  usages: z.array(usageSchema),
});

export type GetUsageSummaryResponse = z.infer<typeof getUsageSummaryResponseSchema>;
